"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.SummaryPhoneNumberInput = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var React = require("react");
var services_1 = require("@falcon/services");
var SummaryPhoneNumberInput = /** @class */ (function (_super) {
    __extends(SummaryPhoneNumberInput, _super);
    function SummaryPhoneNumberInput(props) {
        var _this = _super.call(this, props) || this;
        var phoneNumberValid = services_1.MOBILE_PHONE_REGEX.test(_this.props.phoneNumber);
        _this.state = {
            phoneNumberValid: phoneNumberValid,
            phoneNumber: _this.props.phoneNumber,
            showInputField: !phoneNumberValid
        };
        _this.handlePhoneNumberChange = _this.handlePhoneNumberChange.bind(_this);
        return _this;
    }
    SummaryPhoneNumberInput.prototype.render = function () {
        return ((0, jsx_runtime_1.jsxs)("div", { className: "detail mobile-number ".concat(this.state.showInputField ? "phone-input" : ""), children: [(0, jsx_runtime_1.jsx)("div", { className: "detail-key", children: "Mobile number:" }), (0, jsx_runtime_1.jsxs)("div", { className: "detail-value ".concat(this.state.phoneNumberValid ? "" : "text-danger"), children: [this.state.phoneNumberValid && !this.state.showInputField && this.state.phoneNumber, this.state.showInputField &&
                            (0, jsx_runtime_1.jsx)("input", { id: "phoneNumberInput", onChange: this.handlePhoneNumberChange, placeholder: "07XXXXXXX", type: "tel", className: "form-control mt-2", style: this.state.phoneNumberValid ? undefined :
                                    {
                                        border: "1px solid red",
                                        outline: "none",
                                        boxShadow: "none"
                                    } }), !this.state.phoneNumberValid &&
                            (0, jsx_runtime_1.jsxs)("div", { className: "invalid-feedback d-block", role: "alert", children: [this.state.phoneNumber && "The phone number doesn’t look right...", !this.state.phoneNumber && ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: ["Please enter your mobile phone number.", (0, jsx_runtime_1.jsx)("br", {}), "We'll only use it to contact you about your cover."] }))] })] })] }));
    };
    SummaryPhoneNumberInput.prototype.handlePhoneNumberChange = function (event) {
        event.preventDefault();
        var phoneNumber = event.target.value;
        this.setState({
            phoneNumber: phoneNumber,
            phoneNumberValid: services_1.MOBILE_PHONE_REGEX.test(phoneNumber)
        });
        this.props.onStateChange("policyHolder.phoneNumber", phoneNumber);
    };
    ;
    return SummaryPhoneNumberInput;
}(React.Component));
exports.SummaryPhoneNumberInput = SummaryPhoneNumberInput;
//# sourceMappingURL=SummaryPhoneNumberInput.js.map